import {types} from 'mobx-state-tree';

// MAIN MODEL
export const TechnicalsModel = types.model({
  technicalsScore: types.maybeNull(types.number),
});
